export default __webpack_public_path__ + "static/media/IMG_3240.10d6b065.jpg";